<template>
  <!-- <div> -->
  <Dropdown :style="{width: '100%', position: 'relative'}" class="customDrop" trigger="click">
    <Input
      @on-clear="clear"
      autocomplete="off"
      clearable
      icon="ios-arrow-down"
      placeholder="请选择所属行业"
      readonly
      type="text"
      v-model="industryName"
    >
      <!-- <Icon type="ios-arrow-down" slot="suffix" /> -->
    </Input>
    <DropdownMenu slot="list">
      <div class="industryPanel">
        <RadioGroup @on-change="changeIndustry" v-model="industryCode">
          <!-- <Tree :data="industryData" :render="renderContent" class="selfTree"></Tree> -->
          <Tree :data="synData" :load-data="loadData" :render="renderContent" class="selfTree"></Tree>
        </RadioGroup>
      </div>
    </DropdownMenu>
  </Dropdown>
  <!-- </div> -->
</template>
<script>
export default {
  name: 'industrySelect',
  props: {
    code: '',
  },
  data () {
    return {
      industryName: '',
      industryCode: '',
      industryData: [],
      synData: []
    }
  },
  watch: {
    code: {
      immediate: true,
      handler: function (newValue, oldValue) {
        console.log("newValue", newValue)
        // this.changeIndustry(newValue)
        this.industryCode = newValue
        this.loadDetail(newValue)
      }
    }
  },
  methods: {
    loadDetail: function (val) {
      if (!val) return
      let that = this
      let params = new this.$URLSearchParams()
      params.append("code", val)
      this.$axios.post(that.$apis.dictionaryManager.industry.getByCode, params).then(res => {
        if (res.success) {
          let data = res.result || {}
          this.industryName = data.name
          this.industryCode = data.code
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('行业详情获取失败！')
      })
    },
    loadIndustry: function (pCode) {
      let that = this
      let params = new this.$URLSearchParams()
      if (pCode) params.append("pCode", pCode)
      this.$axios.post(that.$apis.dictionaryManager.industry.getByPCode, params).then(res => {
        if (res.success) {
          that.synData = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('行业树获取失败！')
      })
    },
    loadData (item, callback) {
      console.log(item)
      let that = this
      let params = new this.$URLSearchParams()
      params.append("pCode", item.code)
      this.$axios.post(that.$apis.dictionaryManager.industry.getByPCode, params).then(res => {
        if (res.success) {
          callback(res.result || [])
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('行业树获取失败！')
      })
    },
    renderContent (h, { root, node, data }) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, [
        h('span', {
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }, [
          h('Radio', {
            props: {
              label: data.code,
              selected: data.code == this.industryCode
            },
            style: {
              marginRight: '8px',
            },
            // on: {
            //     'on-change': (check) => {
            //         if(check) this.selected = data.code
            //         console.log(data, check)
            //     }
            // }
          }, data.name),
          // h('span', data.name)
        ])])
    },
    clear: function () {
      this.changeIndustry('')
    },
    changeIndustry: function (check) {
      // if(check) this.selected = data.code
      this.industryName = ''
      this.industryCode = check
      // this.getLabel(check, this.industryData)
      this.getLabel(check, this.synData)
      this.$emit('change', check)
    },
    getLabel: function (value, data) {
      data.forEach(element => {
        if (element.code == value) {
          this.industryName = element.name
        } else {
          this.getLabel(value, element.children || [])
        }
      })
    },
    initTree: function () {
      let that = this
      this.$axios.post(that.$apis.dictionaryManager.industry.getTree).then(res => {
        if (res.success) {
          that.industryData = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('行业树获取失败！')
      }).then(val => {
        that.changeIndustry(that.code)
      })

    }
  },
  beforeMount () {
    // this.initTree()
    this.loadIndustry()
  }
}
</script>
<style scoped>
.industryPanel {
  /* height: 50vh; */
  /* overflow-y: auto; */
  padding: 0 1rem;
}
</style>